<template>
  <div class="list-filter p-x-4 p-t-4 p-b-0">
    <div class="d-f">
      <div>
        <p class="card-content-title">Search</p>
      </div>
      <div class="ml-a">
        <Button @click="filterResetable ? resetFilter() : null" :disabled="!filterResetable" icon="sliders-off-24" class="small minimal-border-radius only-text blue keep-hover">Clear filters</Button>
      </div>
    </div>
    <template v-if="filter.filters.length > 0">
      <Tag v-for="filter in filter.filters" :key="filter.value.value" :icon="tagIcon(filter.type)" :removeable="true" class="m-r-2" @remove="$emit('removeFilter', filter)">{{ filter.value.string }}</Tag>
    </template>
    <template v-else>
      <p style="line-height: 22px; padding-bottom: 10px; padding-left: 8px;">No search filters applied.</p>
    </template>
    <div class="d-f f-g fd-c fd-md-r m-t-2">
      <template v-if="giveaway">
        <div class="f-1">
          <p class="card-content-title">Giveaway</p>
          <FormCheckbox v-for="(filterGiveaway, index) in filter.giveaway" :key="`g${index}`" class="m-b-2" :clickable="true" :selected="filterGiveaway.selected" @input="filter.giveaway[index].selected = !filter.giveaway[index].selected" icon="check" :text="filterGiveaway.string" />
        </div>
      </template>
      <div class="f-1-5">
        <p class="card-content-title">Customer created</p>
        <FormRadio class="small no-border" :items="filterCreated" @input="filterCreated = $event.value" />
        <div class="d-f m-t-2 f-wrap" style="padding-left: 30px;">
          <form-date :disabled="filter.created.type === 'all'" type="date" :value="filter.created.from" icon="arrow-down-medium-24" class="m-r-2 m-b-2" @input="filter.created.from = $event" />
          <form-date :disabled="filter.created.type === 'all'" type="date" :value="filter.created.to" icon="arrow-down-medium-24" class="m-b-2" @input="filter.created.to = $event" />
        </div>
      </div>
      <div class="f-1-5">
        <p class="card-content-title">Last activity</p>
        <FormRadio class="small no-border" :items="filterActivity" @input="filterActivity = $event.value" />
        <div class="d-f m-t-2 f-wrap" style="padding-left: 30px;">
          <form-date :disabled="filter.activity.type === 'all'" type="date" :value="filter.activity.from" icon="arrow-down-medium-24" class="m-r-2 m-b-2" @input="filter.activity.from = $event" />
          <form-date :disabled="filter.activity.type === 'all'" type="date" :value="filter.activity.to" icon="arrow-down-medium-24" class="m-b-2" @input="filter.activity.to = $event" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Tag from '@/components/Common/Tag.vue';

export default {
  components: {
    Tag,
  },
  props: {
    filter: {
      type: Object,
      default: () => ({}),
    },
    giveaway: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filterResetable() {
      return this.filter.created.type !== 'all' || this.filter.activity.type !== 'all' || this.filter.giveaway.findIndex(g => g.selected) >= 0 || this.filter.filters.length > 0;
    },
    filterCreated: {
      get() {
        return [
          { value: 'all', string: 'Show all' },
          { value: 'specific', string: 'Specific period' },
        ].map(type => ({ ...type, selected: type.value === this.filter.created.type }));
      },
      set(value) {
        this.filter.created.type = value;
      },
    },
    filterActivity: {
      get() {
        return [
          { value: 'all', string: 'Show all' },
          { value: 'specific', string: 'Specific period' },
        ].map(type => ({ ...type, selected: type.value === this.filter.activity.type }));
      },
      set(value) {
        this.filter.activity.type = value;
      },
    },
  },
  methods: {
    resetFilter() {
      this.filterCreated = 'all';
      this.filterActivity = 'all';
      this.filter.giveaway = this.filter.giveaway.map(g => ({ ...g, selected: false }));
      this.filter.filters = [];
    },
    tagIcon(type) {
      switch (type) {
        case 'email':
          return 'user-24';
        case 'broadcast_id':
          return 'stream-24';
        case 'giveaway_id':
          return 'gift-24';
        case 'form_id':
          return 'edit-pen2';
        default:
          break;
      }
      return '';
    },
  },
};
</script>

<style lang="scss">
.list-filter {
  border-top: 1px solid #d8dae1;
  .card-content-title {
    font-weight: 500;
    color: #848893;
    margin-bottom: 10px;
  }
}

</style>
